import React, { useRef, useEffect, Dispatch, SetStateAction } from "react";
import { Mtp, useTheme } from "@tvg/design-system";
import useIntersectionObserver from "@tvg/custom-hooks/hooks/useIntersect";
import { isFdr } from "../../../../utils/general";
import { Container } from "./styled-components";
import { Status } from "../../../../types";

interface HeaderProps {
  mtp: number;
  status: Status;
  postTime: string;
  setIsMtpHidden: Dispatch<SetStateAction<boolean>>;
}

const Header = ({ mtp = 0, status, postTime, setIsMtpHidden }: HeaderProps) => {
  const mtpRef = useRef(null);
  const { space } = useTheme();
  const desktopHeader =
    document.body && document.querySelector('[data-qa-label="headerDesktop"]');
  const desktopHeaderHeight =
    (desktopHeader &&
      getComputedStyle(desktopHeader).getPropertyValue("--hdr-height")) ||
    "0px";

  const entry = useIntersectionObserver(
    mtpRef,
    {
      threshold: 1,
      rootMargin: `-${desktopHeaderHeight} 0px 0px 0px`
    },
    () => {
      setIsMtpHidden(false);
    }
  );

  useEffect(() => {
    const allowedStatus: Status[] = ["SK", "RO", "O", "IC"];
    if (entry && allowedStatus.includes(status) && setIsMtpHidden) {
      setIsMtpHidden(!entry?.isIntersecting);
    }
  }, [status, entry?.isIntersecting]);
  return (
    <Container data-qa-label="mtp-container" ref={mtpRef}>
      <Mtp
        mtp={mtp}
        status={status}
        postTime={postTime}
        data-qa-label="mtp-status"
        marginLeft={isFdr() ? space["space-5"] : 0}
      />
    </Container>
  );
};

export default Header;
